import { render } from "./FaceFrown.vue?vue&type=template&id=24479182"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/FaceFrown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24479182"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24479182', __exports__)) {
    api.reload('24479182', __exports__)
  }
  
  module.hot.accept("./FaceFrown.vue?vue&type=template&id=24479182", () => {
    api.rerender('24479182', render)
  })

}


export default __exports__